module.exports = __webpack_public_path__ + "static/media/example_x-ray_hr.26a90976.png";